import { useQuery } from '@tanstack/react-query';

import { getApps } from '@services/sample-requests/app.service';

export function useApps(accessToken?: string) {
  return useQuery({
    queryKey: ['apps'],
    queryFn: () => getApps(accessToken!),
    enabled: !!accessToken,
  });
}
